import { render, staticRenderFns } from "./import-account.vue?vue&type=template&id=18005d63&scoped=true"
import script from "./import-account.vue?vue&type=script&lang=js"
export * from "./import-account.vue?vue&type=script&lang=js"
import style0 from "./import-account.vue?vue&type=style&index=0&id=18005d63&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18005d63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18005d63')) {
      api.createRecord('18005d63', component.options)
    } else {
      api.reload('18005d63', component.options)
    }
    module.hot.accept("./import-account.vue?vue&type=template&id=18005d63&scoped=true", function () {
      api.rerender('18005d63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/import-account.vue"
export default component.exports